"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledColorOverlay = exports.StyledContentWrapperCover = exports.StyledImageLayer = exports.StyledImage = void 0;
var styled_components_1 = __importStar(require("styled-components"));
var getDynamicColors_1 = require("../../../../themes/utils/getDynamicColors");
var hexToRgb = function (hex) {
    var parsedHex = hex.replace('#', '');
    var bigint = parseInt(parsedHex, 16);
    var r = (bigint >> 16) & 255;
    var g = (bigint >> 8) & 255;
    var b = bigint & 255;
    return "".concat(r, ", ").concat(g, ", ").concat(b);
};
exports.StyledImage = styled_components_1.default.img(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n"], ["\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n"])));
exports.StyledImageLayer = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: absolute;\n  inset: 0;\n  overflow: hidden;\n"], ["\n  position: absolute;\n  inset: 0;\n  overflow: hidden;\n"])));
exports.StyledContentWrapperCover = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    border-radius: 1rem;\n    position: relative;\n    overflow: hidden;\n"], ["\n    border-radius: 1rem;\n    position: relative;\n    overflow: hidden;\n"])));
exports.StyledColorOverlay = styled_components_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  position: absolute;\n  inset: 0;\n  ", "\n  mix-blend-mode: normal;\n  border-radius: 1rem;\n"], ["\n  position: absolute;\n  inset: 0;\n  ", "\n  mix-blend-mode: normal;\n  border-radius: 1rem;\n"])), function (_a) {
    var colors = _a.theme.colors;
    return (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    background-color: rgba(", ", 0.3);\n  "], ["\n    background-color: rgba(", ", 0.3);\n  "])), hexToRgb((0, getDynamicColors_1.getPrimaryContainer)(colors)));
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
